// export const colorRandom = ['#05445E', '#189AB4', '#75E6DA', '#D4F1F4']
export const colorRandom = {
    'New Inquiry': '#05445E',
    'In Proposal': '#189AB4',
    'Proposal Made': '#75E6DA',
    'In Discussion': '#2e7981',
}
export const colorTaskRandom = ['#F2CECE', '#E0CEF2', '#CEE0F2']
